<template>
  <div
    class="h-full relative overflow-hidden flex flex-col justify-center items-center"
  >
    <h1 class="font-rakkas 2xl:text-7.4 xl:text-8xl lg:text-4.4 text-white">
      Guild Rework
    </h1>
    <span
      class="w-208 h-3.5 text-center bg-vivid-pink font-mulish-bold text-white text-2 leading-2.2 tracking-wider 2xl:mt-16 xl:mt-10 flex items-center justify-center"
      >1. New Guild Menu</span
    >
    <div class="mt-14 4xl:w-4/12 xl:w-5/12 lg:w-5/12">
      <img class="w-full" :src="`${imgPath}/SystemChanges/guildrework_1.png`" />
    </div>
    <p
      class="font-mulish-medium text-very-pale-orange text-2 xl:text-2 lg:text-1.6 leading-2.2 tracking-wider mt-14"
    >
      * Available in towns only
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style></style>
